import { Box, IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { CardOffersSection } from "../../components/pages/cards";
import { FeatureGuard } from "../../components/shared";
import { useTelegram } from "../../hooks";

/**
 * Отдельная страница выпуска карты. Открывается кликом по «+» из /cards,
 * когда у юзера уже есть выпущенные карты. Внутри — тот же
 * `CardOffersSection`, что раньше висел под списком карт на /cards.
 *
 * Если админ выключил выпуск (`card_issue` feature-flag), `FeatureGuard`
 * покажет соответствующее сообщение и переход сюда будет заблокирован.
 */
export function CardsIssuePage() {
  const { t } = useTranslation("cards");
  const navigate = useNavigate();
  const { tg } = useTelegram();
  const isMobile =
    tg.platform !== "tdesktop" &&
    tg.platform !== "weba" &&
    tg.platform !== "macos";

  return (
    <FeatureGuard feature="card_issue">
      <Box
        sx={{
          display: "grid",
          gap: "24px",
          width: "100%",
          marginTop: isMobile ? "40px" : "20px",
          marginBottom: "120px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "12px",
            marginTop: "6px",
          }}
        >
          <IconButton
            onClick={() => navigate("/cards")}
            aria-label={t("issue_back_aria")}
            sx={{
              width: 36,
              height: 36,
              color: "text.primary",
              bgcolor: "transparent",
              "&:hover": { bgcolor: "transparent" },
            }}
          >
            <Icon icon="solar:arrow-left-linear" width={24} height={24} />
          </IconButton>

          <Typography
            sx={{ fontSize: "24px", fontWeight: 700, textAlign: "center" }}
          >
            {t("apply.title")}
          </Typography>

          {/* Пустой спейсер той же ширины, что и IconButton, — так title
             остаётся оптически центрированным. */}
          <Box sx={{ width: 36, height: 36 }} />
        </Box>

        <CardOffersSection />
      </Box>
    </FeatureGuard>
  );
}
